import type { OnClickOutsideOptions } from '@vueuse/core';

/*
 * Shared types for the tours apps
 */

/**
 * Currencies of tours
 * @example 'KZT', 'EUR', 'USD'
 */
export enum Currency {
  KZT = 'KZT',
  EUR = 'EUR',
  USD = 'USD',
  RUB = 'RUB',
}

/**
 * Code of a meal type in an hotel
 *
 * TODO: Add enum for types and describe each of them and move to a some hotel entity type if it is used only with hotels
 * @example 'OB', 'RO', 'BB'
 */
export type MealType = string;

/**
 * International Air Transport Association (IATA) code of every airport and airline in the world
 *
 * @example
 * 'ALA', 'NQZ', 'ICN' - airports
 * 'KC', 'DV', 'TK' - airlines
 */
export type IATA = string;

export enum PassengerType {
  /**
   * Adult
   */
  ADT = 'ADT',
  /**
   * Child
   */
  CHD = 'CHD',
  /**
   * Infant
   */
  INF = 'INF',
  /**
   * Youth, typically under 25 years old. We don't use this type in tourflow, but it may appear in some responses
   */
  YTH = 'YTH',
}

/**
 * @description Type of a URL string
 *
 * Type to make code more readable and clear
 *
 * @example
 * 'https://aviata.kz/tours', 'https://google.com'
 */
export type URLString = string;

/**
 * @description Type for `v-on-click-outside` handlers
 * We need to explicitly set this to handles, since simply passing a valid prop does not satisfy TS
 */
export type OnOutsideClickHandler = [() => void, OnClickOutsideOptions];
